import { getClaimsId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const CLAIM_BY_ID = "CLAIM_BY_ID";

export function useGetClaimByIdQuery(claimId?: number) {
	return useQuery({
		queryKey: [CLAIM_BY_ID, claimId],
		queryFn: processResponse(() => getClaimsId(claimId!)),
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!claimId,
	});
}
